// Minimal, safe renderer for AI-generated Passport Planner text.
// Security: ALL input is HTML-escaped first — arbitrary HTML/scripts can never render.
// Supported subset: **bold**, *italic*, "- "/"* " bullet lines, blank-line paragraphs.
// Malformed markers degrade gracefully (lone asterisks are stripped).
import React from "react";

function esc(s) {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}

function stripStrayAsterisks(s) {
  // remove unbalanced markers so travelers never see raw ** or *
  let out = s;
  while ((out.match(/\*\*/g) || []).length % 2 !== 0) out = out.replace(/\*\*(?![\s\S]*\*\*)/, "");
  if ((out.replace(/\*\*/g, "").match(/\*/g) || []).length % 2 !== 0) out = out.replace(/\*(?![\s\S]*\*)/, "");
  return out;
}

function inline(text) {
  const clean = esc(stripStrayAsterisks(text));
  const parts = [];
  const re = /\*\*([^*]+)\*\*|\*([^*]+)\*/g;
  let last = 0, m, key = 0;
  while ((m = re.exec(clean))) {
    if (m.index > last) parts.push(clean.slice(last, m.index));
    if (m[1] != null) parts.push(<strong key={key++} className="text-ink font-medium">{m[1]}</strong>);
    else parts.push(<em key={key++}>{m[2]}</em>);
    last = m.index + m[0].length;
  }
  if (last < clean.length) parts.push(clean.slice(last));
  return parts;
}

export function Markdown({ text, className = "" }) {
  const blocks = (text || "").split(/\n{2,}/).map((b) => b.trim()).filter(Boolean);
  return (
    <div className={className}>
      {blocks.map((b, i) => {
        const lines = b.split("\n").map((l) => l.trim()).filter(Boolean);
        const allBullets = lines.length > 0 && lines.every((l) => /^[-*•]\s+/.test(l));
        if (allBullets) {
          return (
            <ul key={i} className="my-3 space-y-2">
              {lines.map((l, j) => (
                <li key={j} className="flex gap-3">
                  <span aria-hidden="true" className="text-gold shrink-0">—</span>
                  <span>{inline(l.replace(/^[-*•]\s+/, ""))}</span>
                </li>
              ))}
            </ul>
          );
        }
        return (
          <p key={i} className="my-3 first:mt-0 last:mb-0">
            {lines.map((l, j) => (
              <React.Fragment key={j}>{j > 0 && <br />}{inline(l.replace(/^[-*•]\s+/, ""))}</React.Fragment>
            ))}
          </p>
        );
      })}
    </div>
  );
}
